module.exports = __webpack_public_path__ + "img/symbol_6.f7ce4b7b.png";